import ReactDOM from 'react-dom/client'
import { BrowserRouter } from 'react-router-dom'
import App from '../pages/App'
import '../brand.css'

ReactDOM.hydrateRoot(
  document.getElementById('app') as HTMLElement,
  <BrowserRouter>
    <App />
  </BrowserRouter>
)
